import { createLink } from '@tanstack/react-router';

import { Link, type LinkProps } from '@/libs/serenity-ui';

export const RouterLink = createLink(({ className, ...props }: LinkProps & { className?: string }) => <Link {...props} />);
